export const CHARM_URL =
  "https://accounts.charmtracker.com/signin?hide_signup=true&hide_secure=true&hide_gsignup=true&servicename=charmphr&serviceurl=https%3A%2F%2Fphr2.charmtracker.com%2Fmain.do";

export const STEMCELL_PAGE_PATH = "/get-started/checkout/836";
